import React, { useState  , useEffect} from 'react';
import { Table, InputGroup, FormControl, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import fetchStockData from '../StockMarketOverview/StockData';
import { Grid , TableContainer, styled, Paper} from '@mui/material';


const InvestTableContainer = styled(TableContainer)({
  margin: '20px auto',
  padding: '0 10px 10px 10px', 
  border: '1px solid #ccc',
  borderRadius: '8px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  width: '100%',
});

function StockList({ onStockSelect , balance}) {
    const symbols = [ 'AAPL','MSFT','GOOGL','AMZN','NVDA','TSLA','META','BRK.B','LLY','V','XOM','UNH','TSM',	'WMT','JPM','NVO','JNJ','MA','PG','HD','ORCL','ABBV','MRK','COST','TM',	'KO',	'ASML',	'PEP',	'ADBE',	'BABA',	'CSCO',	'BAC','NVS','AZN','CRM','TMO','FMX',	'ACN',	'MCD',	'PFE',	'DHR',	'CMCSA','LIN',	'ABT',	'NFLX',	'AMD',	'TMUS',	'TTE',	'HSBC',	'SAP',	'WFC',	'HDB',	'INTC',	'DIS',	'NKE',	'TXN',	'BHP',	'AMGN',	'PM',	'COP',	'INTU',	'CAT',	'VZ',	'MS' , 'FB'];

 const [stocks, setStocks] = useState([]);
   
     

 useEffect(() => {
    const fetchData = async () => {
      for (const symbol of symbols) {
        const newStockData = await fetchStockData(symbol);
        if (newStockData) {
          setStocks((prevStocks) => [...prevStocks, newStockData]);
        }
      }
    };
    fetchData();
  }, []);


      const [searchTerm, setSearchTerm] = useState('');
      
      const filteredStocks = stocks.filter((stock) =>
      stock.symbol.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
 

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    
    // <InvestTableContainer component={Paper}>
      <>
      {/* <p style={{fontWeight:'bold', marginTop : '20px'}}>Current Balance: ${balance}</p> */}
       <Grid container alignItems="center" direction={{ xs: 'column', md: 'row' }} className='Ava_Search'  sx={{ padding: { xs: '10px', md: '15px' },  marginTop: '0px'}}>
        <Grid item xs={12} md={6} >
          <h3>Stocks</h3>
        </Grid>
        <Grid item xs={12} md={6}>
          <InputGroup className='searchBOX'>
            <FormControl
              type="text"
              placeholder="Search Stocks By Symbol"
              value={searchTerm}
              onChange={handleInputChange}
            />
          </InputGroup>
        </Grid>
      </Grid>
      <p style={{textAlign:'left', color:'#5a287d'}}>*Click On Stock To Buy/Sell Stock</p>
      <div style={{ overflowX: 'auto' }}>
      <table class="table table-hover stock-table">
        <thead class="thead-light">
          <tr>
           <th>Stock Symbol</th>
            <th>Company</th>
            <th>Price</th>
            <th>Market capitalization</th>
          </tr>
        </thead>
        <tbody>
          {filteredStocks.map((stock) => (
            <tr key={stock.id} onClick={() => onStockSelect(stock)}>
              <td>{stock.symbol}</td>
              <td>{stock.company}</td>
              <td>${stock.price.toFixed(2)}</td>
              <td>${(stock.marketCap/1000000000)}B</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    {/* </InvestTableContainer> */}
    </>
  );
}

export default StockList;
